export const PERSONALISATION_CUT_OFF_COPY = {
  get readOnlyNotice(): string {
    return I18n.t('react.shared.personalisation.personalisation_cut_off')
  },
} as const

export const PERSONALISATION_TICKET_INFO_COPY = {
  get title(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_title')
  },
  get infoPending(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_info_pending')
  },
  get infoReady(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_info_ready')
  },
  get eventSection(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_event_section')
  },
  get eventLabel(): string {
    return I18n.t('react.shop.payment_tickets.event')
  },
  get ticketLabel(): string {
    return I18n.t('react.shop.payment.form.ticket_name')
  },
  get locationLabel(): string {
    return I18n.t('react.shop.manage.change_attendee_modal.table.location')
  },
  get dateLabel(): string {
    return I18n.t('react.common.date')
  },
  get optionLabel(): string {
    return I18n.t('react.shop.shared.paymentPlan')
  },
  get attendeeSection(): string {
    return I18n.t('react.shop.manage.change_attendee_modal.table.attendee')
  },
  get fullNameLabel(): string {
    return I18n.t('react.shared.full_name')
  },
  get emailLabel(): string {
    return I18n.t('react.shared.email')
  },
  get addressLabel(): string {
    return I18n.t('react.common.address')
  },
  get statusSection(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_status_section')
  },
  get assignmentLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_assignment_label')
  },
  get statusLabel(): string {
    return I18n.t('react.common.status')
  },
  get statusValid(): string {
    return I18n.t('react.shared.state.valid')
  },
  get statusUsed(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_status_used')
  },
  get closedScanned(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_closed_scanned')
  },
  get ticketCodeLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_code_label')
  },
  get walletLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_wallet_label')
  },
  get walletAddTo(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_wallet_add_to')
  },
  get walletApple(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_wallet_apple')
  },
  get walletGoogle(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_wallet_google')
  },
  get closedInvalid(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_closed_invalid')
  },
  get qrPendingTitle(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_qr_pending_title')
  },
  get qrPendingBody(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_qr_pending_body')
  },
  get back(): string {
    return I18n.t('react.common.back')
  },
  get complete(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_complete')
  },
  get edit(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_info_edit')
  },
} as const

export const ETICKETS_CLOSED_COPY = {
  get title(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_closed_title')
  },
  get body(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_closed_body')
  },
  get notice(): string {
    return I18n.t('react.shared.personalisation.personalisation_ticket_closed_notice')
  },
} as const

// `assigned` includes already-confirmed seats; `pasted` is what the count check judges.
export const BULK_ASSIGN_COPY = {
  assignedCount: (assigned: number, total: number): string =>
    I18n.t('react.shared.personalisation.personalisation_ticket_assigned_count', { assigned, total }),
  pastedCount: (pasted: number, seats: number): string =>
    I18n.t('react.shared.personalisation.personalisation_ticket_pasted_count', { pasted, seats }),
  stageAction: (count: number): string =>
    I18n.t('react.shared.personalisation.personalisation_ticket_stage_action', { count }),
  notifyNote: (count: number): string =>
    I18n.t('react.shared.personalisation.personalisation_ticket_notify_note', { count }),
} as const

export const PERSONALISATION_STATUS_LABELS: Record<string, string> = {
  get unassigned(): string {
    return I18n.t('react.shared.personalisation.personalisation_status_unassigned')
  },
  get sent(): string {
    return I18n.t('react.shared.personalisation.personalisation_status_sent')
  },
  get personalised(): string {
    return I18n.t('react.shared.personalisation.personalisation_status_personalised')
  },
  get transferred(): string {
    return I18n.t('react.shared.personalisation.personalisation_status_transferred')
  },
}

export const MANAGE_TABLE_COPY = {
  columns: {
    get name(): string {
      return I18n.t('react.common.name')
    },
    get email(): string {
      return I18n.t('react.shared.email')
    },
    get code(): string {
      return I18n.t('react.common.code')
    },
    get type(): string {
      return I18n.t('react.common.type')
    },
    get location(): string {
      return I18n.t('react.shop.manage.change_attendee_modal.table.location')
    },
    get date(): string {
      return I18n.t('react.common.date')
    },
    get assignment(): string {
      return I18n.t('react.shared.personalisation.personalisation_ticket_info_assignment_label')
    },
    get ticketStatus(): string {
      return I18n.t('react.shared.personalisation.personalisation_ticket_info_status_section')
    },
  },
  get searchPlaceholder(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_search_placeholder')
  },
  get noSearchMatches(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_no_search_matches')
  },
  get selectAll(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_select_all')
  },
  selectedCount: (count: number): string =>
    I18n.t('react.shared.personalisation.personalisation_manage_table_selected_count', { count }),
} as const

// "Filter:" / "Sort:" prefixes keep three identical dropdowns apart.
export const MANAGE_TABLE_CONTROLS_COPY = {
  get statusFilterLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_status_filter_label')
  },
  get ticketTypeFilterLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_ticket_type_filter_label')
  },
  get ticketTypeSortLabel(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_ticket_type_sort_label')
  },
  get allTicketTypes(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_ticket_all_ticket_types')
  },
  get sortNone(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_sort_none')
  },
  get sortAsc(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_sort_asc')
  },
  get sortDesc(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_sort_desc')
  },
  get noTicketTypeMatches(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_no_ticket_type_matches')
  },
  get noFilterMatches(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_no_filter_matches')
  },
  get resetFilters(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_controls_reset_filters')
  },
} as const

// Never claim a printed ticket or scan code stops working.
export const REMOVE_ASSIGNMENT_COPY = {
  get action(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_action')
  },
  get undoAction(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_undo_action')
  },
  get stagedMarker(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_staged_marker')
  },
  get groupHeading(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_group_heading')
  },
  get rowNote(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_row_note')
  },
  hiddenStagedRemovals: (count: number): string =>
    I18n.t('react.shared.personalisation.personalisation_manage_table_remove_assignment_hidden_staged_removals', {
      count,
    }),
} as const

export const REVIEW_SEND_COPY = {
  get intro(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_intro')
  },
  get newGroup(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_new_group')
  },
  get editedGroup(): string {
    return I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_edited_group')
  },
  removalSummary: (count: number): string =>
    I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_removal_summary', { count }),
  confirmAction: (emailCount: number): string =>
    emailCount === 0
      ? I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_confirm_action_save_changes')
      : I18n.t('react.shared.personalisation.personalisation_manage_table_review_send_confirm_action_save_and_send', {
          count: emailCount,
        }),
} as const
